import { Form, Input } from "antd";
import { LabeledField } from "../../../../../common/components/labeledField/labeledField";

const { TextArea } = Input;

export default function UDFTextArea({
  title = "Title",
  isFormItem = true,
  value,
  className,
  placeholder = "",
  formItemName = "",
  required = true,
  params,
  style = {},
  disabled = false,
  extraLabel = null,
}) {
  const renderField = () => (
    <TextArea
      {...params}
      placeholder={placeholder}
      style={style}
      disabled={disabled}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        className={className}
        label={title}
        name={formItemName}
        initialValue={value}
        rules={required && [{ required: true, message: `Enter  ${title}` }]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={title} required={required} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
}
